<template>
    <form>
        <div class="form-group">
            <FormLabel for="activated-accounts-range" class="mb-3">Enter estimated number of activated accounts:</FormLabel>
            <div class="row">
                    <div class="col-sm-9 d-flex align-items-center">
                        <button type="button" @click="decreaseAccounts" aria-label="Increase number of accounts" class="btn btn-link mr-2">
                            <i class="text-danger fa fa-minus"></i>
                        </button>
                        <FormInput
                            type="range"
                            min="0"
                            max="100"
                            step="1"
                            v-model="accounts"
                            class="custom-range form-control-range"
                            id="activated-accounts-range"
                        />
                        <button type="button" @click="increaseAccounts" aria-label="Decrease number of accounts" class="btn btn-link ml-2">
                            <i class="text-secondary fa fa-plus"></i>
                        </button>
                    </div>
                    <div class="col-sm-3">
                        <FormLabel for="activated-accounts-text" class="sr-only">Enter estimated number of activated accounts:</FormLabel>
                        <FormInput
                            @input="updateAccounts"
                            @keyup="checkForInvalidKeys($event.keyCode)"
                            @blur="formatAccounts($event.currentTarget.value)"
                            v-model.number="accounts"
                            class="text-center mt-3 mt-sm-0"
                            id="activated-accounts-text"
                        />
                    </div>
            </div>
        </div>
        <div class="h-divider"></div>
        <div class="calculator-price">
            <div class="mb-3 d-flex justify-content-between align-items-center flex-column flex-md-row">
                <h3 class="mb-0">You could earn:</h3>
                <div class="total-price text-secondary font-weight-bold line"><sup>$</sup>{{ earned }}</div>
            </div>
            <div class="d-flex justify-content-md-start justify-content-center">
                <a href="/member-calculator">Member reports calculator</a>
            </div>
        </div>
    </form>
</template>

<script>
import FormLabel from '@/components/form/FormLabel';
import FormInput from '@/components/form/FormInput';

const FIELD = 'Field';
const CONTACT_CENTER = 'Contact Center';

export default {
    components: {
        FormInput,
        FormLabel
    },
    props: {
      type: {
          type: String,
          default: FIELD
      }
    },
    data() {
        return {
            accounts: 15,
            dollarsPerAccount: this.type === FIELD ? 30 : 15,
            FIELD_CALCULATOR: FIELD,
            CONTACT_CENTER_CALCULATOR: CONTACT_CENTER
        }
    },
    computed: {
        earned() {
            if (isNaN(this.accounts)) {
                return 0;
            }

            return this.accounts * this.dollarsPerAccount;
        }
    },
    methods: {
        checkForInvalidKeys(keyCode) {
            const invalidKeyCodes = [107, 109, 187, 189];

            if (invalidKeyCodes.find(invalidKeyCode => invalidKeyCode === keyCode)) {
                this.accounts = 0;
            }
        },
        formatAccounts(accounts) {
            this.accounts = parseInt(accounts, 10);
        },
        validateAccounts(amount) {
            const minAmount = 0;
            const maxAmount = 100;

            if (isNaN(parseInt(amount))) {
                return minAmount;
            }

            if (amount >= minAmount && amount <= maxAmount) {
                return amount;
            } else {
                if (amount > maxAmount) {
                    return maxAmount;
                }

                if (amount < minAmount) {
                    return minAmount;
                }
            }
        },
        updateAccounts(accounts) {
            if (!accounts.toString().length) {
                accounts = 0;
            }

            this.accounts = this.validateAccounts(accounts);
        },
        increaseAccounts() {
            const increment = 1;
            this.accounts = this.validateAccounts(parseInt(this.accounts) + increment);
        },
        decreaseAccounts() {
            const reduction = 1;
            this.accounts = this.validateAccounts(parseInt(this.accounts) - reduction);
        }
    }
}
</script>
